import { describeHandler } from "../inspector.js";
import "./handler.js";
import { dispatchAction } from "../tree/tree.js";
//#region src/handler/metadata.ts
function createDataHandler(key, defaultValue) {
	const dataHandlerFactory = (value = defaultValue) => {
		const dataHandler = (action, { next }) => {
			if (import.meta.env.FIVEWAY_INSPECTOR ?? import.meta.env.DEV) describeHandler(action, {
				name: "data",
				key
			});
			if (action.kind === "query" && action.key === key) {
				action.value = typeof value === "function" ? value() : value;
				return null;
			}
			return next();
		};
		return dataHandler;
	};
	dataHandlerFactory.key = key;
	dataHandlerFactory.query = (tree, id) => {
		const query = {
			kind: "query",
			key,
			value: null
		};
		dispatchAction(tree, query, id);
		return query.value;
	};
	return dataHandlerFactory;
}
//#endregion
export { createDataHandler };

//# sourceMappingURL=metadata.js.map